import { render } from "./TransferEvent.vue?vue&type=template&id=5afeba1f&scoped=true"
import script from "./TransferEvent.vue?vue&type=script&lang=js"
export * from "./TransferEvent.vue?vue&type=script&lang=js"

import "./TransferEvent.vue?vue&type=style&index=0&id=5afeba1f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5afeba1f"]])

export default __exports__